import { CreateAreaReworkPayload } from "@types";

export const filteredAreas = (searchValue: string, areas: CreateAreaReworkPayload) => {
    if (searchValue.length === 0) return true;

    const searchNormalized = removeAccents(searchValue.toLowerCase());

    return (
        removeAccents(areas.name?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(areas.scope?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(areas.interestType?.toLowerCase() || '').includes(searchNormalized) ||
        removeAccents(String(areas.velocityMin || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(areas.velocityMax || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(areas.stayTimeMin || '').toLowerCase()).includes(searchNormalized) ||
        removeAccents(String(areas.stayTimeMax || '').toLowerCase()).includes(searchNormalized)
    );
};

const removeAccents = (str: string): string => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};